<template>
  <list :reference="reference" :sorters="sorters" :active-sort="activeSort">
    <template slot-scope="invoice">
      <list-card
        :title="`Invoice #${invoice.item.invoiceNum}`"
        :subtitle-dark="
          `Total ${$formatCurrency(invoice.item.total, invoice.item.currency)}`
        "
        :label="invoice.item.status"
        :timestamp="invoice.item.dateCreated.toDate()"
        :route="{ path: `/admin/invoices/${invoice.item._id}` }"
      />
    </template>
  </list>
</template>

<script>
import { collection } from "@firebase/firestore";
export default {
  name: "AdminInvoices",
  data() {
    return {
      reference: collection(this.$firestore, "invoices"),
      sorters: [
        {
          field: "invoiceNum",
          label: "Invoice Number"
        },
        {
          field: "total",
          label: "Total"
        },
        {
          field: "dateCreated",
          label: "Date Created"
        }
      ],
      activeSort: {
        field: "dateCreated",
        direction: "desc"
      }
    };
  }
};
</script>
